import FeatureFlagClient from "../client/FeatureFlagClient";
import {jwtDecode} from "jwt-decode";


class FeatureFlagUtil {
    cachedFeatureFlags = null;
    cachedJti = null;

    async isFeatureEnabled(featureName) {
        try {
            const token = this._getAccessToken();
            if (!token) return false;

            const decoded = jwtDecode(token);
            const userScopes = new Set(decoded.scope ? decoded.scope.split(" ") : []);
            const currentJti = decoded.jti || null;

            const featureFlags = await this._getFeatureFlags(currentJti);

            if (!Array.isArray(featureFlags)) return false;

            const feature = featureFlags.find((f) => f.name === featureName);
            if (!feature?.enabled) return false;

            if (!feature.scopes?.length) return true;

            return feature.scopes.some((scope) => userScopes.has(scope));
        } catch (error) {
            console.error("[FeatureFlagUtil] Failed to check feature:", error);
            return false;
        }
    }

    async _getFeatureFlags(currentJti) {
        if (this.cachedFeatureFlags && this.cachedJti === currentJti) {
            return this.cachedFeatureFlags;
        }

        if (this.cachedFeatureFlags && this.cachedJti !== currentJti) {
            this._updateFeatureFlagsFromServer(currentJti); // Асинхронное обновление
            return this.cachedFeatureFlags;
        }

        const featureFlags = await this._fetchFeatureFlagsFromServer(currentJti);
        this._updateCache(featureFlags, currentJti);
        return featureFlags;
    }

    async _updateFeatureFlagsFromServer(currentJti) {
        try {
            const featureFlags = await this._fetchFeatureFlagsFromServer(currentJti);
            this._updateCache(featureFlags, currentJti);
        } catch (error) {
            console.error("[FeatureFlagUtil] Failed to update feature flags from server:", error);
        }
    }

    async _fetchFeatureFlagsFromServer(currentJti) {
        try {
            console.log("[FeatureFlagUtil] Fetching feature flags from server");
            return await FeatureFlagClient.getFeatureFlags();
        } catch (error) {
            console.error("[FeatureFlagUtil] Failed to fetch feature flags from server:", error);
            throw error;
        }
    }

    _updateCache(featureFlags, currentJti) {
        this.cachedFeatureFlags = featureFlags;
        this.cachedJti = currentJti;
        console.log("[FeatureFlagUtil] Cache updated");
    }

    _getAccessToken() {
        for (const key in localStorage) {
            if (key.includes(".accessToken")) {
                return localStorage.getItem(key);
            }
        }
        return null;
    }
}

const featureFlagUtil = new FeatureFlagUtil();

export default featureFlagUtil;
